module.exports = {
	"version": "121",
	"version_date": "Oct 2025"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/Version.json
// module id = 968
// module chunks = 0